// Release Switch Toggles: should not be used directly
// @see getReleaseSwitchToggleCookieName util
export const RELEASE_SWITCH_TOGGLE = 'release-switch'
export const RELEASE_SWITCH_TOGGLE_AT = 'release-switch-at'

// Release Toggles
export const RELEASE_TOGGLE_SAE_ONLY = 'sae-only'
export const RELEASE_TOGGLE_MARKETPLACE = 'marketplace'
export const RELEASE_TOGGLE_CART_CTA_DELAYED = 'cart-cta-delayed'
export const RELEASE_TOGGLE_ERX = 'erx'
export const RELEASE_TOGGLE_NOW = 'now'
export const RELEASE_TOGGLE_MP_CROSS_SELL = 'mp-cross-sell'
export const RELEASE_TOGGLE_VARIANT_ATTTRIBUTES_ENABLED = 'enabled'
export const RELEASE_TOGGLE_VARIANT_ATTRIBUTES = 'variant-attributes'
export const RELEASE_TOGGLE_HOME_ONE = 'home-one'
export const REBRANDING_IT_TOGGLE = 'rebranding-it'
export const REBRANDING_COM_TOGGLE = 'rebranding-com'
export const ERX_ADYEN_TOGGLE = 'erx-adyen'
export const ERX_ADYEN_MP_TOGGLE = 'erx-adyen-mp'
export const ERX_NOW_TOGGLE = 'erx-now'
export const APPLE_PAY_TOGGLE = 'wstra-2462'
export const CPH_MAX_DOSAGE_TOGGLE = 'wstra-5851'
export const HOME_ONE_ACCOUNT = 'wsssh-2348'
export const WELCOME_PAGE_TOGGLE = 'wscr-2386'

// Experiments
export const AD_FLYOUT_BANNER = 'cro-1333'
export const XSELL_NEW_LAYOUT = 'xsell-new-layout'
export const PDP_CSW_NEW_ALGO = 'pdp-csw-new-algo'
export const SERVICE_LINKS_CSW = 'service-links-csw'
export const ODS_CLIENT_FLOW = 'ods-client-flow'
export const ODS_PDP_MODAL = 'wsssh-188'
export const ODS_PDP_TOOLTIP = 'wsssh-859'
export const NEW_HEADER = 'header'
export const PDP_VARIANTS_POSITION = 'cro-459'
export const CSW_PRODUCT_TITLE = 'cro-780'
export const NEW_CDN = 'cro-1881'
export const SERP_NOW_PUSH = 'cro-121'
export const SERP_LOAD_MORE = 'cro-179'
export const VARIANT_ATTRIBUTES = 'variant-attributes'
export const NEW_CSW = 'cro-513'
export const EXTENDED_SEARCHBOX_RESULTS = 'cro-1244'
export const TOP_DEALS_LABEL = 'cro-1073'
export const NEWSLETTER_MODAL_FR = 'cro-2521'
export const NEWSLETTER_MODAL_CH = 'cro-2522'
export const PDP_CSW_POSITION_CHANGE = 'cro-1969'
export const HOME_CSW_RANKING = 'cro-1972'
export const MOBILE_SERVICES_HOMEPAGE = 'cro-2258'
export const CONFIRMATION_PAGE_CSW = 'cro-1891'
export const CTA_BUTTON_ON_ALL_CSW = 'cro-2052'
export const CART_CSW_THREE_PRODUCTS = 'cro-2119'
export const SPECIAL_SALE_OFFERS_MODAL = 'cro-1905'
export const CHANGE_GTM_SCRIPT_COM = 'cro-2468'
export const CHANGE_GTM_SCRIPT_FR = 'cro-3124'
export const CROSSSELL_LAYOUT = 'cro-1942'
export const REDCARE_INFO_MODAL_FR = 'cro-2749'
export const REDCARE_INFO_MODAL_CH = 'cro-3181'
export const SWAP_EXPERIMENT = 'wsssh-3182'
export const NOW_PDP_GB_FUNCTIONALITY = 'wstra-5030'
export const NOW_HOMEPAGE_GB_FUNCTIONALITY = 'wstra-5032'
export const NOW_SERP_GB_FUNCTIONALITY = 'wstra-5031'
export const NOW_CATEGORY_GB_FUNCTIONALITY = 'wstra-5033'
export const CART_MAX_DOSAGE = 'wstra-6126'
export const SHIPPING_DELAY_NOTIFICATION = 'wstra-6359'
export const NEW_SEARCH_PAGE_LAYOUT = 'wsawa-3056'
export const NEW_SEARCH_PAGE_LAYOUT_V3 = 'wsawa-3327'

export const ORDER_HELP_MODAL_LINK = 'wsssh-2747'

export const ALGOLIA_SPLIT = 'alg'

// ad-server experiments' name
export const AD_SERVER = 'ad-server'
export const AD_SERVER_SEARCH_PRODUCT = 'ad-se'
export const AD_SERVER_CROSSSELL_PRODUCT = 'ad-xs'
export const AD_SERVER_BANNER = 'ad-ba'

export const HIDE_VIDEO_CONSULTATION = 'wsssh-1561'
export const RETAIL_MEDIA_CROSS_SELL_SERVICE = 'rmadt-954'
export const RETAIL_MEDIA_SEARCH_BOOSTER = 'rmadt-1506'
export const TOTAAL_KORTING_AB_TEST = 'wscnl-5650'

// test different pricing strategies
export const DIFFERENT_PRICING_STRATEGY = 'wsawa-2829'
export const DIRECT_CHANNEL = 'direct'

export const ONE_TIME_PASSWORD_FAKE_DOOR_TEST = 'wscnl-6729-fake-door'

export const SHOW_CONTACT_INFORMATION = 'wscnl-7196'
